import { render, staticRenderFns } from "./pointOrigin.vue?vue&type=template&id=32141f76&"
import script from "./pointOrigin.vue?vue&type=script&lang=js&"
export * from "./pointOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports